export function formatTiersGroupe(groupes) {
  groupes.forEach(groupe => {
    groupe.tiersEnfants.forEach(enseigne => {
      enseigne.tiersEnfants.forEach(pdv => {
        pdv.tiersParentGroupeId = groupe.id;
      });
    });
  });
  return groupes;
}

export function limitTiers(data, tiersId) {
  data.forEach(tiers1 => {
    if (tiers1.typologie === 'Groupe') {
      tiers1.tiersEnfants = tiers1.tiersEnfants
        .filter(el => {
          const findPdv = el.tiersEnfants
            .filter(pdv => tiersId.includes(pdv.id));
          return findPdv.length;
        });
      tiers1.tiersEnfants.forEach(value => {
        value.tiersEnfants = value.tiersEnfants
          .filter(pdv => tiersId.includes(pdv.id));
      });
    }
    if (tiers1.typologie === 'Enseigne') {
      tiers1.tiersEnfants = tiers1.tiersEnfants
        .filter(pdv => tiersId.includes(pdv.id));
    }
  });
}

export function gestionLogoTiers(data) {
  data.forEach(tiers => {
    if (tiers.typologie === 'Groupe') {
      tiers.tiersEnfants.forEach(child => {
        child.chemin = child.chemin ? child.chemin : tiers.chemin;
        child.tiersEnfants.forEach(pdv => {
          pdv.chemin = pdv.chemin ? pdv.chemin : child.chemin;
        });
      });
    }
  });
}
